import { UI, useAlert, HStack, VStack } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { OrderStepMobileProps } from '../mobile';

export interface MobileSwitchesProps {
  channelOptions: OrderStepMobileProps['channelOptions'];
  onChannelSelectChange: OrderStepMobileProps['onChannelSelectChange'];
  selectedChannels: OrderStepMobileProps['selectedChannels'];
}

export const MobileSwitches: React.FC<MobileSwitchesProps> = ({
  channelOptions,
  onChannelSelectChange,
  selectedChannels,
}) => {
  const { alert } = useAlert();

  return (
    <VStack space="stack.xxxs">
      {channelOptions?.map((option) => (
        <HStack alignItems={'center'} justifyContent={'space-between'} key={option.label}>
          <UI.Text color="neutral.black">{option.label}</UI.Text>
          {!option.isInvalid && (
            <UI.Switch
              onToggle={(value: boolean) => onChannelSelectChange(option.value, value)}
              isChecked={selectedChannels?.includes(option.value)}
              isDisabled={!!option.disabled}
            />
          )}
          {option.isInvalid && (
            <UI.Switch
              isChecked={true}
              onTrackColor={Utils.ColorToken.WithOpacity('feedback.error.default', 0.5)}
              onThumbColor={Color['feedback.error.default']}
              onToggle={() => {
                alert(
                  {
                    icon: 'Warning',
                    iconColor: 'feedback.attention.default',
                    title: 'Atenção',
                    description:
                      'Este cliente está restrito a receber\noportunidades por este canal.',
                  },
                  () => {}
                );
              }}
            />
          )}
        </HStack>
      ))}
    </VStack>
  );
};
